import { type FC, ReactNode } from "react";
import clsx from "clsx";

type Variant = "outlined" | "filled";
type Width = "small" | "medium" | "large" | "custom";
type Height = "small" | "medium" | "large" | "custom";

interface GxButtonSmProps {
  variant?: Variant;
  children: ReactNode;   // Accepts text, div, icon, etc.
  onClick?: () => void;
  bgColor?: string;      // hex: "#172375" or CSS color name: "black"
  textColor?: string;    // hex: "#ffffff" or CSS color name: "white"
  disabled?: boolean;
  width?: Width;
  customWidth?: string;
  height?: Height;        // new prop
  customHeight?: string;  // for custom height
  className?: string;
}

const GxButtonSm: FC<GxButtonSmProps> = ({
  variant = "outlined",
  children,
  onClick,
  bgColor,
  textColor,
  disabled,
  width = "medium",
  customWidth,
  height = "small",        
  customHeight,
  className,
}) => {
  const widthClass =
    width === "small"
      ? "gx-btn-sm-w-small"
      : width === "medium"
        ? "gx-btn-sm-w-medium"
        : width === "large"
          ? "gx-btn-sm-w-large"
          : "";

  const heightClass =
    height === "small"
      ? "gx-btn-sm-h-small"
      : height === "medium"
        ? "gx-btn-sm-h-medium"
        : height === "large"
          ? "gx-btn-sm-h-large"
          : "";

  const inlineStyle: React.CSSProperties = {};

  if (variant === "outlined") {
    if (bgColor) {
      inlineStyle.borderColor = bgColor;
      inlineStyle.color = bgColor;
    }
  } else {
    if (bgColor) inlineStyle.backgroundColor = bgColor;
    if (textColor) inlineStyle.color = textColor;
  }

  if (customWidth) inlineStyle.width = customWidth;
  if (customHeight) inlineStyle.height = customHeight;

  return (
    <button
      className={clsx(
        "gx-button-sm",
        "gx-p12-sb",
        variant === "outlined" ? "gx-btn-outlined" : "gx-btn-filled",
        widthClass,
        heightClass,
        disabled && "gx-disabled",
        className,
      )}
      style={inlineStyle}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default GxButtonSm;
